<template>
  <div class="header-wrapper">
    <div class="container" :class="{ line: $route.path === '/reg' }">
      <div class="content">
        <div class="left">
          <!--<div v-if="$route.path === '/'"><img src="../assets/img/longlogo.png"></div>-->
          <!--<div v-else><img src="../assets/img/logo.png"></div>-->
          <div @click="toFontPage" style="cursor: pointer">
            <img :src="picAddr + cos.cosweblogourl" />
          </div>
        </div>
        <div v-if="
          $route.path !== '/expertLogin' &&
          $route.path !== '/login' &&
          $route.path !== '/forgotpwd' &&
          $route.name != 'BidToday'
        " class="right">
          <div class="search header_search">
            <div class="input">
              <el-input v-model="searchcontent" placeholder="输入项目名称，支持模糊查询" @keydown.enter.native="search"></el-input>
            </div>
            <div class="btn" @click="search">搜索</div>
          </div>
          <div class="login" v-if="webLoginUser">
            <span @click="inSystem">工作台</span><span class="line">|</span><span @click="loginout">退出登录</span>
          </div>
          <div class="login" v-else>
            <span @click="login">用户登录</span><span class="line">|</span><span @click="reg">免费注册</span>
          </div>
        </div>
      </div>
    </div>
    <div class="menu" v-if="
      $route.path !== '/expertLogin' &&
      $route.path !== '/login' &&
      $route.path !== '/forgotpwd' &&
      $route.path !== '/reg' &&
      $route.name != 'BidToday'
    ">
      <div class="content header_nav">
        <div>
          <nav-slider :haveActive="+showtype === 5 ? false : true" :currentTab="parentActiveTab.index" :navs="navs"
            @change="navChange"></nav-slider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import navSlider from "../components/common/navSlider";
import request from "@/utils/request";

export default {
  name: "Header",
  components: { navSlider },
  data() {
    return {
      searchcontent: "",
      navs: [],
      model: {},
      ww: window,
      showtype: "",
    };
  },
  async created() {
    await this.getNavs();
    await this.getCosModel();
    await this.routingCorrection();
  },
  methods: {
    async isNavUrl() {
      let flg = false
      this.navs.forEach(e => {
        if (String(e.url) === String(this.$route.name)) {
          flg = true
        }

      })
      if (this.$route.url === '/') flg = false
      return flg
    },
    async routingCorrection() {
      let flg = await this.isNavUrl()
      if (!flg) return
      let arr = this.navs.filter((val, index) => {
        if (index === Number(this.$route.query.id)) return val;
      });
      this.$store.commit("changeState", { searchinfo: "" });

      this.$store.commit("changeState", { parentActiveTab: arr[0] });

      this.$store.commit("changeState", {
        childActiveTab:
          arr[0].children && arr[0].children.length ? arr[0].children[0] : "",
      });
    },
    inSystem() {
      window.location.replace(
        `${this.obWebUrl}mainIndex?t=${this.webLoginUser.token}`
      );
    },
    toFontPage() {
      this.$router.replace({ path: "/" });
    },
    loginout() {
      if (this.webLoginUser) {
        this.$confirm("是否确定退出登录？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let local = window.localStorage;
            local.clear();
            this.$store.commit("changeState", { webLoginUser: "" });
          })
          .catch(() => { });
      }
    },
    async getCosModel() {
      let res = await request({
        method: "get",
        url: "/web/web/getWebCosList",
        params: { cosflg: 1 },
      });
      this.model = res.length ? res[0] : {};
    },
    navChange(value, obj) {
      if (+obj.showtype === 5) {
        this.showtype = 5;
        this.ww.open(obj.datawhere, "_blank");
        return;
      }
      this.showtype = "";
      obj.last = "";
      this.$store.commit("changeState", { searchinfo: "" });
      this.$store.commit("changeState", { parentActiveTab: obj });
      if (obj.url === "/") {
        this.$store.commit("changeState", {
          childActiveTab:
            this.navs.length && this.navs[1].children
              ? this.navs[1].children[0]
              : "",
        });
        this.$router.push({ path: obj.url });
      } else {
        // 先注释
        // let index = this.parentActiveTab.children.findIndex(v => v.value === 0)
        // if (index !== -1) {
        //   this.parentActiveTab.children.splice(0, 1)
        // }
        this.$store.commit("changeState", {
          childActiveTab:
            this.parentActiveTab.children &&
              this.parentActiveTab.children.length
              ? this.parentActiveTab.children[0]
              : "",
        });
        this.$router.push({ name: obj.url, query: { id: obj.index } });
      }
    },
    async getNavs() {
      this.loading = true;
      let res = await request({
        method: "get",
        url: "/web/web/getWmenuTree",
        params: { cosid: this.cosId },
      });
      this.navs = res.list;
      this.loading = false;
      this.$store.commit("changeState", { menus: this.navs });
      if (!this.parentActiveTab) {
        this.$store.commit("changeState", { parentActiveTab: this.navs[0] });
      }

      if (this.$route.path === "/") {
        if (!this.childActiveTab) {
          this.$store.commit("changeState", {
            childActiveTab:
              this.navs.length && this.navs[1].children
                ? this.navs[1].children[0]
                : "",
          });
        }
      }
    },
    search() {
      // if (!this.searchcontent) {
      //   this.searchcontent = '清空'
      // }
      // this.$store.commit('changeState', {'searchinfo': this.searchcontent})
      // this.searchcontent = ''
      if (!this.searchcontent) {
        this.$message({
          message: "请输入搜索关键词！",
          type: "warning",
        });
        return;
      }
      let { href } = this.$router.resolve({
        name: "searchResult",
        query: { name: this.searchcontent },
      });
      window.open(href, "_blank");
      // console.log('搜索')
    },
    login() {
      // console.log('登录')
      this.$router.push({ path: "/login" });
    },
    reg() {
      // console.log('注册')
      this.$router.push({ path: "/reg" });
    },
  },
  computed: {
    ...mapGetters([
      "obWebUrl",
      "picAddr",
      "parentActiveTab",
      "searchinfo",
      "cosId",
      "childActiveTab",
      "webLoginUser",
      "cos",
    ]),
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

@media screen and (min-width: 1205px) {
  .header-wrapper {
    .container {
      display: flex;
      justify-content: center;

      .content {
        width: 1201px;
        padding: 34px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .left {
          display: flex;
          height: 62px;

          img {
            height: 62px;
          }

          .text {
            color: $color-orange;
            font-weight: bold;
            font-size: $fontsize-large-xxx;
          }
        }

        .right {
          display: flex;
          height: 44px;
          line-height: 42px;

          .search {
            font-size: $fontsize-large;
            display: flex;
            border: 1px solid $color-orange;
            width: 400px;
            margin-right: 20px;

            .input {
              flex: 1;
            }

            .btn {
              color: #ffffff;
              background-color: $color-orange;
              padding: 0 30px;
              cursor: pointer;
            }
          }

          .login {
            font-size: $fontsize-medium;
            padding: 0 15px;
            border: 1px solid $color-orange;
            color: $color-orange;
            display: flex;

            span {
              cursor: pointer;
            }

            .line {
              padding: 0 10px;
            }
          }
        }
      }
    }

    .line {
      border-bottom: 1px solid #e6e6e6;
    }

    .menu {
      display: flex;
      justify-content: center;

      .content {
        text-align: left;
        width: 1201px;
        display: flex;
        align-items: center;
        padding-bottom: 2px;
      }
    }
  }
}

@media screen and (max-width: 1205px) {
  .header-wrapper {
    .container {
      width: 100%;

      .content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 7px;

        .left {
          width: 220px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .right {
          .header_search {
            display: none;
          }

          .login {
            font-size: 0.6em;
            border: 1px solid #f46722;
            padding-left: 5px;
            padding-right: 5px;
            color: #f46722;

            span {
              padding: 2px;
            }
          }
        }
      }
    }

    .menu {
      // display: none;
    }
  }
}
</style>
